var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47,
    fill: "url(#paint0_linear_2011_25)",
    stroke: "url(#paint1_radial_2011_25)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 38.8934C69.9923 43.1452 69.6542 47.3482 68.8262 51.5229C67.5179 58.131 63.7218 63.1087 58.3599 67.0822C55.557 69.1602 52.4813 70.7473 49.1251 71.7835C48.5718 71.9546 47.8879 72.0881 47.3615 71.9283C39.823 69.6359 33.8483 65.2826 29.7467 58.6519C27.6565 55.2726 26.9342 51.4213 26.4404 47.5475C25.7642 42.2294 25.9429 36.9095 26.4635 31.5933C26.6364 29.8237 26.8554 29.5868 28.6324 29.1016C34.7301 27.4355 40.822 25.7562 46.9292 24.1295C47.569 23.9584 48.3393 23.9565 48.9791 24.1258C55.2112 25.7806 61.426 27.5013 67.6524 29.1749C68.7109 29.4589 69.3122 30.0136 69.391 31.1156C69.5774 33.7088 69.7944 36.3021 70 38.8934ZM46.2184 48.4765C45.8342 48.1229 45.5979 47.918 45.375 47.6998C43.9035 46.2612 42.4357 44.8189 40.9622 43.3822C39.7269 42.1768 39.0738 42.1862 37.8173 43.4123C37.5234 43.7 37.2256 43.9858 36.9355 44.2773C35.9001 45.3153 35.8828 46.0807 36.9106 47.0924C39.483 49.6236 42.063 52.1491 44.6469 54.669C45.6939 55.6901 46.4816 55.6939 47.5171 54.6878C49.2884 52.9652 51.0481 51.2333 52.8117 49.507C55.3457 47.0266 57.8816 44.5481 60.4098 42.0621C61.4491 41.0391 61.4395 40.2906 60.4021 39.2526C60.0447 38.8934 59.6836 38.538 59.3166 38.1901C58.2965 37.2216 57.5261 37.216 56.5176 38.1995C53.413 41.229 50.3123 44.2622 47.2212 47.3049C46.862 47.6528 46.5681 48.0628 46.2184 48.4765Z",
    fill: "url(#paint2_radial_2011_25)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2011_25",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8178FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2011_25",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9909 31.9457) scale(66.7143 66.7141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2011_25",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6625 39.9729) scale(30.5774 33.3571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.592d72d06eff9559f3d61f79ea8f716c.svg";
export { ForwardRef as ReactComponent };